import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer,Box} from "@mui/material";
import style from "./style";
import CustomPagination from "../../../../../components/CustomPagination";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import{ ProfitData }from "../../../../../constants/data"
// import { useAlert } from "../../../../context/AlertContext";
import { ReactComponent as Growth } from "../../../../../assets/invoice/ant-design_product-outlined.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";


const SalesReportList = () => {

  
  const [page, setPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const {showAlert} =useAlert();
  
  return (
    <>

           
      <TableContainer  sx={style.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={style.tableHead}>Product Name</TableCell>
              <TableCell sx={style.tableHead}>Price</TableCell>
              <TableCell sx={style.tableHead}>Sales Date</TableCell>
              <TableCell sx={style.tableHead}>Delivery Report</TableCell>
              <TableCell sx={style.tableHead}>Payement Status</TableCell>
              <TableCell sx={style.tableHead}>Action</TableCell>




            </TableRow>
          </TableHead>
          <TableBody>
            {/* {ProfitData?.length === 0 ? ( 
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : ( 
              ProfitData?.map((item, index) => ( */}
            <TableRow>
              <TableCell sx={style.tabledata}><Box sx={style.productGrid}><Growth />Product</Box></TableCell>
              <TableCell sx={style.tabledata}>$699</TableCell>
              <TableCell sx={style.tabledata}>8 March 2024</TableCell>
              <TableCell sx={style.tabledata}>Delivered</TableCell>

              <TableCell sx={style.tabledatas}>Success</TableCell>
              <TableCell sx={style.tabledata}><MoreVertIcon /> </TableCell>



            </TableRow>
            {/* ))
            )} */}
          </TableBody>

        </Table>
        {ProfitData &&
       <CustomPagination
         //  pageCount={totalCount}         
         page={page}
         setPage={setPage}
         rowsPerPage={rowsPerPage}
         setRowsPerPage={setRowsPerPage}
         totalItems={ProfitData.length}
       />} 

      </TableContainer>


    </>
  );
};
export default SalesReportList;

